import { getContestCategoryContent } from "../../data/cccdContestCategories"
import type { GalleryMember, GalleryTeam } from "../../hooks/useCccdTeamGallery"

export const UNASSIGNED_CATEGORY = "__unassigned__"

export const ROLE_LABEL: Record<string, string> = {
  student: "Estudiante",
  tutor: "Tutor",
}

export function initials(firstName: string | null, lastName: string | null): string {
  return `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase() || "?"
}

export function locationLine(city: string | null, country: string | null): string | null {
  const parts = [city, country].filter(Boolean)
  return parts.length > 0 ? parts.join(", ") : null
}

export function categoryLabel(slug: string | null): string {
  if (slug === null) return "Categoría sin asignar"
  return getContestCategoryContent(slug)?.title ?? "Categoría sin asignar"
}

/** 'Ana R.' — privacy-friendly display used across the gallery. */
export function shortName(m: Pick<GalleryMember, "firstName" | "lastName">): string {
  const first = m.firstName?.trim() ?? ""
  const last = m.lastName?.trim()?.[0]
  const name = last ? `${first} ${last.toUpperCase()}.` : first
  return name.trim() || "Integrante"
}

export function memberCountLabel(n: number): string {
  return `${n} ${n === 1 ? "integrante" : "integrantes"}`
}

export function institutionLine(team: GalleryTeam): string | null {
  const parts = [team.institutionName, team.institutionCity].filter(Boolean)
  return parts.length > 0 ? parts.join(" · ") : null
}

/** Never blank; first 6 first-names then 'y N más'. */
export function groupPhotoAlt(team: GalleryTeam): string {
  const names = team.members.map((m) => m.firstName?.trim()).filter((n): n is string => !!n)
  const head = names.slice(0, 6).join(", ")
  const rest = names.length - 6
  const list = rest > 0 ? `${head} y ${rest} más` : head
  return list ? `Foto de grupo del equipo ${team.name}: ${list}` : `Foto de grupo del equipo ${team.name}`
}

export function normalize(s: string): string {
  return s.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase()
}

export function searchHaystack(team: GalleryTeam): string {
  return normalize(
    [
      team.name,
      team.institutionName,
      team.institutionCity,
      categoryLabel(team.categorySlug),
      ...team.members.map((m) => `${m.firstName ?? ""} ${m.lastName ?? ""}`),
    ]
      .filter(Boolean)
      .join(" ")
  )
}
